import { Form, Button, Row, Col } from "react-bootstrap";
import { ChangeEvent, useState } from "react";
import { TranslatorService } from "../../../services/translator-service";
import { ICoordsWithNameData } from "../../../dto/converters/ICoordsWithNameData";
import {useTranslation} from 'react-i18next';

const CrdMudelTextArea = (props: {isValga: boolean}) => {

    const [crdMudelFormInputData, setCrdMudelFormInputData] = useState({ dirLestToLks: true, inputData: [] as ICoordsWithNameData[]});
    const [resultFromApi, setResultFromApi] = useState([] as ICoordsWithNameData[]);
    const [resultError, setResultError] = useState("");
    const {t} = useTranslation();

    const queryToApi = async (body: {dirLestToLks: boolean, inputData: ICoordsWithNameData[]}) => {
        setResultError("");
        let result = await TranslatorService.queryApiPost<ICoordsWithNameData[]>(
            props.isValga ? "/valgacrdmudel" : "/crdmudel",
            body,
        );

        if (!result.ok) {
            setResultError(t('requestError') + ": " + result.statusCode);
        } else {
            setResultFromApi(result.data!);
        }
    }
    
    function parseTxt(e: ChangeEvent<HTMLTextAreaElement>) {
        const resultArray = [] as ICoordsWithNameData[];
        e.target.value.split(/[\r\n]+/).forEach((line) => {
            var splitElements = line.trim().split(/\s+/)
            if (splitElements.length === 3 && !isNaN(Number(splitElements[1].replace(/[,]/g, "."))) && !isNaN(Number(splitElements[2].replace(/[,]/g, ".")))) {
                const name = splitElements[0];
                const numberX = Number.parseFloat(splitElements[1].replace(/[,]/g, "."));
                const numberY = Number.parseFloat(splitElements[2].replace(/[,]/g, "."));
                resultArray.push({"nimi": name, "x": numberX, "y": numberY});
            }
            });
            setCrdMudelFormInputData({ ...crdMudelFormInputData, inputData: resultArray});
    }

    function generateResult() {
        var resultString = "";
        resultFromApi.forEach(object => {
            if (object.x && object.y) {
                resultString = resultString + object.nimi + " " + (typeof(object.x) !== "string" ? object.x.toFixed(3) : object.x) + " " + (typeof(object.y) !== "string" ? object.y.toFixed(3) : object.y) + "\r\n";
            } else {
                resultString = resultString + object.nimi + " - " + t('outsideCrdModelArea') + "\r\n";
            }
        })
        return resultString;
    }

    return (
        <>
            <Form.Group className="mb-3">
                <Row>
                    <Col>
                        <Form.Check type="radio" name="textAreaForm" aria-label="geo-lest-tekst" label={t('directionLESTToLKS')} defaultChecked onChange={e => {setCrdMudelFormInputData({ ...crdMudelFormInputData, dirLestToLks: true }); setResultFromApi([]);}} />
                    </Col>
                    <Col>
                        <Form.Check type="radio" name="textAreaForm" aria-label="lest-geo-tekst" label={t('directionLKSToLEST')} onChange={e => {setCrdMudelFormInputData({ ...crdMudelFormInputData, dirLestToLks: false }); setResultFromApi([]);}} />
                    </Col>
                </Row>
                <Row>
                    <Col>
                        {t('fourColumnTextAreaDescription')}<br/>
                        {t('inputInColumns')}:
                        <ul>
                            <li>
                                {t('dataFieldNameText')}
                            </li>
                            <li>
                                {crdMudelFormInputData.dirLestToLks === true ? <span>x<sub>L-EST97</sub></span> : <span>x<sub>LKS-92 TM</sub></span> }
                            </li>
                            <li>
                                {crdMudelFormInputData.dirLestToLks === true ? <span>y<sub>L-EST97</sub></span> : <span>y<sub>LKS-92 TM</sub></span> }
                            </li>
                        </ul>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <Form.Control as="textarea" aria-label="tekst" rows={5} onChange={parseTxt}/>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <Button 
                        onClick={(e) => {e.preventDefault(); queryToApi(crdMudelFormInputData);}} 
                        disabled={crdMudelFormInputData.inputData.length === 0} 
                        type="submit"
                        aria-label="arvuta">
                            {t('calculateButtonLabel')}
                        </Button>
                    </Col>
                </Row>
                {(resultError.length > 0) ?
                    <Row>
                        <Col>
                            <span className="error-message">{resultError}</span>
                        </Col>
                    </Row>
                    :
                    ""
                }
                {resultFromApi.length > 0 && 
                    <Row>
                        <Col>
                            {t('answer')}: <br />
                            <Form.Control as="textarea" readOnly aria-label="vastus" rows={5} value={generateResult()} />
                        </Col>
                    </Row>
                }
            </Form.Group>
            <br /><br /><br />
        </>
    );

}

export default CrdMudelTextArea;

